import { render, staticRenderFns } from "./RenewalReview.vue?vue&type=template&id=e5181c3a&scoped=true"
import script from "./RenewalReview.vue?vue&type=script&lang=js"
export * from "./RenewalReview.vue?vue&type=script&lang=js"
import style0 from "./RenewalReview.vue?vue&type=style&index=0&id=e5181c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5181c3a",
  null
  
)

export default component.exports